import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import socials from "./footer_var";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-copywright">
          <h3>Designed and Developed by Goutom Roy</h3>
        </Col>
        <Col md="4" className="footer-copywright">
          <h3>Copyright © {year} SR</h3>
        </Col>
        <Col md="4" className="footer-body">
          <ul className="footer-icons">

            {socials.map((e) => {
              return <li className="social-icons">
                <a
                  href={e.href}
                  style={{ color: "white" }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <e.icon />
                </a>
              </li>

            })}


          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
